import React from 'react';
import { SalesLanding } from './pages/SalesLanding';
export function App() {
  return <SalesLanding data-id="element-0" data-mp="35ckb29dc16k1" />;
}